import { FISHING_CONTEST_CATEGORIES } from "./contract.js";
import { itemGroupAppliedMarkup } from "../query/item-group-presentation.js";
import { escapeHtml, queryIconMarkup } from "../query/presentation.js";

export function contestQueryLabelMarkup(t) {
  return `<span class="inline-flex items-center gap-1.5">${queryIconMarkup("medal-fill")}<span>${escapeHtml(t("contest.query_title"))}</span></span>`;
}

export function contestQueryTermView(selectedFish, t) {
  const members = new Map();
  for (const category of FISHING_CONTEST_CATEGORIES) {
    const fish = selectedFish?.[category];
    if (fish) members.set(fish.itemId, { ...fish, grade: category });
  }
  const label = t("contest.query_title");
  const presentation = { directMembers: [...members.values()], itemIds: [...members.keys()] };
  const groupLabelMarkup = `<span class="inline-flex min-w-max items-center gap-2">
    ${contestQueryLabelMarkup(t)}
    <button type="button" class="btn btn-xs btn-soft" data-query-contest-voting
      aria-label="${escapeHtml(`${label}: ${t("contest.view_results_vote")}`)}"
      data-fishy-tooltip="${escapeHtml(t("contest.view_results_vote"))}" aria-haspopup="dialog">${escapeHtml(t("contest.vote"))}</button>
    </span>`;
  return { type: "term", key: "fishing-contest", label, kindLabel: t("map.search.kind.filter"),
    reserveSecondaryRow: members.size > 0,
    contentMarkup: itemGroupAppliedMarkup(presentation, members, { groupLabelMarkup, interactiveLabel: true }) };
}
